import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { Box, Button, Menu, MenuItem } from "@mui/material";
import MyTemplateForm from "./MyTemplateForm";
import { setCurrentEmms } from "../../redux/slices/currentEmmsSlice";
import { setEmmsHeaders } from "../../redux/slices/emmsAuthSlice";
import Templates from "./Templates";
import Login from "../Login";
import TitleWithDropdown from "../TitleWithDropdown";
import image from "../../logos/schedule.png";
import "../../components/CommonDashboard.css";
import { setTemplate } from "../../redux/slices/templateSlice";
import ScheduleTable from "./ScheduleTable";
import MyScheduleForm from "./MyScheduleForm";
import { setMeeting } from "../../redux/slices/meetingSlice";
import { setLocation } from "../../redux/slices/locationSlice";
import { setMeetingSpaces } from "../../redux/slices/allMeetingSpacesSlice";
import { setPlaylist } from "../../redux/slices/playlistSlice";
import { setEventcustomisation } from "../../redux/slices/eventcustomisationsSlice";
import FallBackContent from "./FallBackContent";
import { setScreenuser } from "../../redux/slices/screenusersSlice";
import { setLayout } from "../../redux/slices/layoutSlice";
import ClientUrlModal from "./ClientUrlModal";


function ScheduleDashboard({ selected }) {
  const dispatch = useDispatch();

  const emms = useSelector((state) => state.emms);
  const headers = useSelector((state) => state.header);
  const [login, setLogin] = useState(false);

  const [responseData, setResponseData] = useState(null);
  const [errors, setErrors] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState(emms?.emms?.[0]?.id);
  const [selectedChoice, setSelectedChoice] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const meetingData = useSelector((state) => state?.meeting?.meeting);
  const [showModel, setShowModel] = useState(false);
  const [showClientUrlModel, setShowClientUrlModel] = useState(false);


  const getData = () => {
    const api = localStorage.getItem("api");

    const requestBody1 = {
      path: "location",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    const requestBody2 = {
      path: "meetingspace",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    const requestBody3 = {
      path: "screenusers",
      query: { },
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };
    const requestBody4 = {
      path: "layout",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    const request1 = axios.post(api + `/emms/piggyback`, requestBody1, headers);

    const request2 = axios.post(api + `/emms/piggyback`, requestBody2, headers);
    const request3 = axios.post(api + `/emms/piggyback`, requestBody3, headers);
    const request4 = axios.post(api + `/emms/piggyback`, requestBody4, headers);

    axios
      .all([request1, request2, request3, request4])
      .then(
        axios.spread((response1, response2, response3, response4) => {
          dispatch(setLocation(response1.data));
          dispatch(setMeetingSpaces(response2.data));
          dispatch(setScreenuser(response3.data));
          dispatch(setLayout(response4.data));
        })
      )
      .catch((error) => {
        console.error(error);
      });
  };
  const fetchData = (value) => {
    setIsLoading(true);
    let selectedEmms = emms?.emms?.find((element) => element.id === value);
    const api = localStorage.getItem("api");

    if (selectedEmms !== null) {
      const apiId = selectedEmms?.apiId;
      const apiKey = selectedEmms?.apiKey;
      dispatch(setCurrentEmms(selectedEmms));

      const emmsheaders = {
        headers: {
          "Content-Type": "application/json",
          "x-api-id": apiId,
          "x-api-key": apiKey,
        },
      };

      dispatch(setEmmsHeaders(emmsheaders));
      const requestBody = {
        path: "meeting/contentai",
        query: {},
        emmsId: value,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.headers,
      };

      axios
        .post(api + `/emms/piggyback`, requestBody, headers)
        .then((response) => {
          setResponseData(response.data);
          dispatch(setMeeting(response.data));
          setErrors(false);
        })
        .catch(() => {
          setErrors(true);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    getData();
    fetchData(selectedOption);
  }, [selectedOption]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleChoiceSelect = () => {
    setSelectedChoice(true);
    setAnchorEl(null);
  };

  const options = emms?.emms?.map((emm) => ({
    label: emm.name,
    value: emm.id,
  }));

  return login == null ? (
    <Login />
  ) : (
    <>
    <div className="mainContainer emms-main-container">
      <header style={{ marginLeft: "10%" }}>
        <figure>
          <img className="img content-ai-header-image" src={image} alt="Logo" />
        </figure>
      </header>
      <div className="title-container">
        <div className="title">
          <TitleWithDropdown
            title="EMMS Service"
            options={options}
            selectedOption={selectedOption}
            onOptionChange={(event) => setSelectedOption(event.target.value)}
          />
        </div>
        <Box sx={{
          display: "flex",
          gap: { xs: "0.5rem", md: "1.5rem" },
          flexDirection:{
            xs:"column",
            md:"row"
          },
          alignItems:{xs:"start",md:"center"}
        }}>
          {" "}
          <Button
            variant="contained"
            sx={{ textTransform: "none" }}
            onClick={() => setShowClientUrlModel(true)}
          >
            Client Url
          </Button>
          <Button
            variant="contained"
            sx={{ textTransform: "none" }}
            onClick={() => setShowModel(true)}
          >
            Fallback Content
          </Button>
          <MyScheduleForm />
        
          {showModel && <FallBackContent setshowmodel={setShowModel} />}
        </Box>
      </div>

      <div className="emms-main-container-left-align" style={{ marginLeft: "10%" }}>
        <ScheduleTable selectedOption={selectedOption} errors={errors} isLoading={isLoading} />
      </div>
      {/* Render the modal for Client URL */}
      <ClientUrlModal
        isOpen={showClientUrlModel}
        onClose={() => setShowClientUrlModel(false)}
        emmsId={selectedOption}
        emmsheaders={emmsheaders?.emmsheaders}
        headers={headers}
      />
    </div>

    </>
  );
}

export default ScheduleDashboard;
